module.exports = __webpack_public_path__ + "static/media/4.e78e3cc6.png";